import { useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

import { scrollToTopLegalTabLinks } from "../helpers";

const TabLinks = ({ tabSelected }) => {
  const location = useLocation();

  let { id } = useParams();
  const [activeTab, setActiveTab] = useState(id);

  useEffect(() => {
    if (location.pathname === "/legal/pp") {
      setActiveTab("pp");
      scrollToTopLegalTabLinks();
    }
    if (location.pathname === "/legal/tou") {
      setActiveTab("tou");
      scrollToTopLegalTabLinks();
    }
  }, [location]);

  return (
    <div className="tab-links">
      <div className="tab-links__nav">
        <ul className="tab-links__nav__items">
          <Link
            to="/legal/tou"
            className={activeTab === "tou" ? "tab-links--active" : ""}
          >
            Terms of Use
          </Link>
          <Link
            to="/legal/pp"
            className={activeTab === "pp" ? "tab-links--active" : ""}
          >
            Privacy Policy
          </Link>
        </ul>
      </div>
    </div>
  );
};

export default TabLinks;
